<script lang="ts" setup>
import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { useVesselStore } from "@/stores/master/vessel";
import { hasAccess } from "@/utils/helper";

const linkAdd = {
  text: "Add Vessel",
  url: "/master/vessel/create",
};

const headers: Header[] = [
  { text: "VESSEL NAME", value: "name" },
  { text: "SHIP OWNER", value: "ship_owner_name" },
  { text: "IMO NO", value: "imo" },
  { text: "MMSI", value: "mmsi" },
  { text: "CALL SIGN", value: "call_sign" },
  { text: "VESSEL CLASS", value: "vessel_class_code" },
  { text: "VESSEL TYPE", value: "vessel_type_name" },
  { text: "ACTIONS", value: "action" },
];

const isLoading = ref(false);
const vesselStore = useVesselStore();
const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listVessel = ref<any>([]);

const loadDataVessel = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await vesselStore.dispatchGetAll(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listVessel.value = await vesselStore.vessels.items;
    page.value = await vesselStore.vessels.page;
    limit.value = await vesselStore.vessels.pageSize;
    totalItems.value = await vesselStore.vessels.total;
  }
  isLoading.value = false;
};

const handleEdit = (role: any) => {
  router.push("/master/vessel/" + role);
};

const handleDelete = async (ship: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${ship.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await vesselStore.dispatchDelete(ship.id);
        swalWithBootstrapButtons.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

loadDataVessel();
</script>
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
      >
        <h3 class="mb-0">List Data Ship</h3>
      </div>
      <FilterTable :link="linkAdd" @searchByQuery="loadDataVessel" />
      <div class="table-content">
        <BaseLoading v-if="isLoading" />
        <EasyDataTable
          :headers="headers"
          :items="listVessel"
          v-if="!isLoading"
          show-index
        >
          <template #item-action="props">
            <div class="d-flex gap-2">
              <button
                v-if="hasAccess('vessel-update')"
                class="btn btn-info btn-sm text-white"
                @click="handleEdit(props.id)"
              >
                Edit
              </button>
              <button
                v-if="hasAccess('vessel-delete')"
                class="btn btn-danger btn-sm"
                @click="handleDelete(props)"
              >
                Delete
              </button>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
</template>
